import React from 'react';
import { Link } from 'react-scroll';
import config from '../../config';

export default class Footer extends React.Component {
  state = {
    name: '',
    email: '',
    message: '',
    errors: {
      name: '',
      email: '',
      message: '',
    },
  };

  validateEmail = email => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  onBlur = e => {
    switch (e.target.name) {
      case 'name':
        if (!e.target.value) {
          this.setState({
            errors: {
              ...this.state.errors,
              name: 'Name should not be empty.',
            },
          });
        } else {
          this.setState({ errors: { ...this.state.errors, name: '' } });
        }
        break;

      case 'email':
        if (!e.target.value) {
          this.setState({
            errors: {
              ...this.state.errors,
              email: 'Email should not be empty.',
            },
          });
        } else if (!this.validateEmail(e.target.value)) {
          this.setState({
            errors: { ...this.state.errors, email: 'Email is not valid.' },
          });
        } else {
          this.setState({ errors: { ...this.state.errors, email: '' } });
        }
        break;

      case 'message':
        if (!e.target.value) {
          this.setState({
            errors: {
              ...this.state.errors,
              message: 'Message should not be empty.',
            },
          });
        } else {
          this.setState({ errors: { ...this.state.errors, message: '' } });
        }
        break;

      default:
        break;
    }
  };

  checkFormErrors = () => {
    const { errors } = this.state;
    for (const error of Object.values(errors)) {
      if (error) {
        return false;
      }
    }
    return true;
  };

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
    this.onBlur(e);
  };

  render() {
    const { name, email, message, errors } = this.state;
    return (
      <section id="footer">
        <div id="contact" className="inner">
          <h2 className="major">Get in touch</h2>
          <p>
            Need more information not available on this page or want to start a
            new project? You can use the contact form below, or reach out to me
            via email or phone. I will respond within 24 hours.
          </p>
          <form
            name="Contact Form"
            method="POST"
            netlify-honeypot="bot-field"
            data-netlify="true"
          >
            <p className="hidden" style={{ height: 0, margin: 0 }}>
              <label>
                Don’t fill this out if you’re human: <input name="bot-field" />
              </label>
            </p>
            <input type="hidden" name="form-name" value="Contact Form" />
            <div className="fields">
              <div className="field">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  value={name}
                  onChange={this.onChange}
                  onBlur={this.onBlur}
                />
                {errors.name && <p className="error-message">{errors.name}</p>}
              </div>
              <div className="field">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  value={email}
                  onChange={this.onChange}
                  onBlur={this.onBlur}
                />
                {errors.email && (
                  <p className="error-message">{errors.email}</p>
                )}
              </div>
              <div className="field">
                <label htmlFor="message">Message</label>
                <textarea
                  name="message"
                  id="message"
                  rows="4"
                  value={message}
                  onChange={this.onChange}
                  onBlur={this.onBlur}
                ></textarea>
                {errors.message && (
                  <p className="error-message">{errors.message}</p>
                )}
              </div>
            </div>
            <ul className="actions">
              <li>
                <input
                  type="submit"
                  value="Send Message"
                  disabled={
                    !(name && email && message && this.checkFormErrors())
                  }
                />
              </li>
            </ul>
          </form>
          <ul className="contact">
            <li className="fa-home">{config.address}</li>
            <li className="fa-phone">
              <a href="tel:+2348••••••••••">{config.phone}</a>
            </li>
            <li className="fa-envelope-o">
              <a href="mailto:mailstochristian@gmail.com">{config.email}</a>
            </li>
          </ul>
          <ul className="copyright">
            <li>
              <Link
                to="page-wrapper"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
                className="anchor"
              >
                Christian Effiong
              </Link>{' '}
              &copy; {new Date().getFullYear()}
            </li>
            <div>
              {config.socialLinks.map(social => {
                const { icon, url } = social;
                return (
                  <span key={url}>
                    <a href={url} target="_blank" rel="noopener noreferrer">
                      <i className={`fa ${icon}`}></i>
                    </a>
                  </span>
                );
              })}
            </div>
          </ul>
        </div>
      </section>
    );
  }
}
